<!-- Energy widget version: 1.0 -->
<script lang="ts">
	import { Container } from '@Shelly/shelly-design-system';
	import EmInsights from 'src/components/EnergyMonitoring/sections/EmInsights.svelte';

	export let staticPreview = false;
</script>

<Container type="glass" noScroll fullHeight>
	<EmInsights embedded {staticPreview} />
</Container>
